import { createSlice } from "@reduxjs/toolkit";
import accessToken from "../utils/access-token";
import Router from "next/router";
import { MixpanelTracking } from "../MixPanel";

const authSlice = createSlice({
    name : 'auth',
    initialState : {
        user : {
            isLoggedIn : false,
            name : '',
        },
        authModal : false,
        redirectTo : null,
        showLoginRegisterToggler : true
    },
    reducers : {
        handleAuthModal(state, action) {
            state.authModal = action.payload;
            if(action.payload)
                MixpanelTracking.getInstance().authStarted();
        },

        changeLoginRegisterToggler(state, action) {
            state.showLoginRegisterToggler = action.payload;
        },

        setUserDetails(state, action) {
            state.user.isLoggedIn = action.payload.isLoggedIn;
            state.user.name = action.payload.name;

            if(state.redirectTo) {
                Router.push(state.redirectTo);
                state.redirectTo = null;
            }
        },

        setRedirectTo(state, { payload }) {
            state.redirectTo = payload;
        },

        logout(state) {
            accessToken.removeCredentials();
            state.user.isLoggedIn = false;
            state.user.name = '';

            MixpanelTracking.getInstance().loggedOut()
            MixpanelTracking.getInstance().reset();

            if(state.redirectTo) {
                Router.push(state.redirectTo);
                state.redirectTo = null;
            }
        }
    }
});

export default authSlice.reducer;
export const { 
    handleAuthModal, 
    changeLoginRegisterToggler, 
    setUserDetails, 
    setRedirectTo, 
    logout 
} = authSlice.actions;